import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  CoreRequestService,
  StorageService,
  SharedChangesService,
  ProgressChangesService,
  ShopboxApiService,
  ProgressCounterService,
  ProgressLoaderService,
  BatchCredentialsService,
} from '../services';

import {
  AccountService,
  ClientService,
  CustomerService,
  BasketService,
  DiscountGroupService,
  DefaultPaymentService,
  CategoryService,
  CountryService,
  BranchService,
  GraphService,
  ProductService,
  FilterService,
  TaxService,
  MenuService,
  VariantService,
  CashRegisterService,
  ArchiveService,
  InventoryService,
  StaffService,
  CustomPaymentService,
  SalesService,
  GiftCardService,
  TransactionReportService,
  PrinterGroupService,
  DiscountCodeService,
  ReturnCodeService,
  CategoryGraphService,
  ItemsGraphService,
  PaymentWeightService,
  IntegrationService,
  ClipCardService,
  // PaylikeService,
  RoomService,
  TableService,
  PromotionCodeService,
  LabelPrinteService,
} from '../services/api';

import { CachingInterceptor, HttpTokenInterceptor, BlobErrorHttpInterceptor, LoaderInterceptor } from '../interceptors';
import { CacheMapService, Cache } from '../services/cache';
import { environment } from '../../../environments/environment';
import { GlobalErrorHandler } from '../global';


export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpInterceptor, multi: true},
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
];

export const ApiInterceptorProviders = [
  ShopboxApiService,
  ClipCardService
];



@NgModule({ imports: [CommonModule], providers: [
        HttpInterceptorProviders,
        CacheMapService,
        { provide: Cache, useClass: CacheMapService },
        CoreRequestService,
        StorageService,
        SharedChangesService,
        ProgressCounterService,
        ProgressLoaderService,
        ProgressChangesService,
        AccountService,
        ClientService,
        CustomerService,
        BasketService,
        DiscountGroupService,
        DefaultPaymentService,
        CategoryService,
        CountryService,
        BranchService,
        GraphService,
        ProductService,
        FilterService,
        TaxService,
        MenuService,
        VariantService,
        CashRegisterService,
        ArchiveService,
        InventoryService,
        StaffService,
        CustomPaymentService,
        SalesService,
        GiftCardService,
        TransactionReportService,
        PrinterGroupService,
        DiscountCodeService,
        ReturnCodeService,
        CategoryGraphService,
        ItemsGraphService,
        PaymentWeightService,
        IntegrationService,
        // PaylikeService,
        RoomService,
        TableService,
        PromotionCodeService,
        LabelPrinteService,
        ApiInterceptorProviders,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        BatchCredentialsService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule { }
